<template>
	<div v-title title="商品列表" :class="`product-list-page ${dataList && dataList.length ? '' : 'bg-fff'}`">
		<div class="top-box">
			<div class="search-box">
				<img class="icon" src="@/assets/images/product/icon_search.png" alt="" />
				<input class="input" type="text" v-model="searchForm.keyword" placeholder="请输入商品名称" enterkeyhint="search"
					@keyup.enter="search" />
				<img v-if="searchForm.keyword" class="icon-clear" src="@/assets/images/product/icon_clear.png" alt=""
					@click="searchForm.keyword = ''" />
				<div class="line" v-if="searchForm.keyword"></div>
				<span class="text" @click="search">搜索</span>
			</div>
			<div class="sort-style-box">
				<van-tabs class="van-tabs" @click="changeTab" title-active-color="#00754A" :border="false" type="line"
					v-model="active">
					<van-tab>
						<span slot="title" class="title-box">
							上架时间
							<img v-if="active !== 0" class="icon-sort" src="@/assets/images/product/icon_sort.png" alt="" />
							<img v-if="active === 0 && timeOrder === 0" class="icon-sort"
								src="@/assets/images/product/icon_sort_up.png" alt="" />
							<img v-if="active === 0 && timeOrder === 1" class="icon-sort"
								src="@/assets/images/product/icon_sort_down.png" alt="" />
						</span>
					</van-tab>
					<van-tab>
						<span slot="title" class="title-box">
							销量
							<img v-if="active !== 1" class="icon-sort" src="@/assets/images/product/icon_sort.png" alt="" />
							<img v-if="active === 1 && saleOrder === 0" class="icon-sort"
								src="@/assets/images/product/icon_sort_up.png" alt="" />
							<img v-if="active === 1 && saleOrder === 1" class="icon-sort"
								src="@/assets/images/product/icon_sort_down.png" alt="" />
						</span>
					</van-tab>
					<van-tab>
						<span slot="title" class="title-box">
							价格
							<img v-if="active !== 2" class="icon-sort" src="@/assets/images/product/icon_sort.png" alt="" />
							<img v-if="active === 2 && priceOrder === 0" class="icon-sort"
								src="@/assets/images/product/icon_sort_up.png" alt="" />
							<img v-if="active === 2 && priceOrder === 1" class="icon-sort"
								src="@/assets/images/product/icon_sort_down.png" alt="" />
						</span>
					</van-tab>
					<!-- <van-tab title-class="row-col-tab">
            <span slot="title" class="row-col-box">
              <img
                v-if="gridType === 0"
                class="icon-row-col"
                src="@/assets/images/product/icon_row.png"
                alt=""
              />
              <img
                v-if="gridType === 1"
                class="icon-row-col"
                src="@/assets/images/product/icon_col.png"
                alt=""
              />
            </span>
          </van-tab> -->
				</van-tabs>
				<div class="style-box">
					<img v-if="gridType === 0" @click="gridType = 1" class="icon-row-col"
						src="@/assets/images/product/icon_row.png" alt="" />
					<img v-if="gridType === 1" @click="gridType = 0" class="icon-row-col"
						src="@/assets/images/product/icon_col.png" alt="" />
				</div>
			</div>
		</div>
		<div class="h94"></div>

		<van-list v-if="dataList && dataList.length" class="van-list" v-model="loading" :finished="finished"
			finished-text="没有更多了" @load="loadContent">
			<div :class="`goods-list ${gridType === 1 ? 'showType-one' : 'showType-two'
		}`">
				<div class="goods-item" v-for="(item, index) in dataList" :key="index"
					@click="productDetail(item.product.publishId)">
					<img class="img" :src="item.product.pic" alt="" />
					<div class="goods-info">
						<div class="title">
							<span class="free-tag" v-if="item.product.freeTerm">免息</span>
							{{ item.product.name }}
						</div>

						<div class="tag" v-if="checkChannelPromotionExist(item) || item.shopPromotionBest"
							v-show="checkChannelPromotionExist(item)" style="margin-right: 5px">
							{{ getChannelPromotionDesc(item) }}
						</div>
						<div class="tag" v-if="checkChannelPromotionExist(item) || item.shopPromotionBest"
							v-show="item.shopPromotionBest">
							{{ getShopPromotionDesc(item) }}
						</div>
						<div class="price" v-if="item.product.freeTerm">
							<span class="symbol">¥</span>
							<span class="num">{{ item.product.freePrice }}</span>
							<span class="text">/期起</span>
							<div class="sum-price">¥{{ item.product.price }}</div>
						</div>
						<div class="sum-price" :style="`margin-top:8px`" v-else-if="!item.product.freeTerm">
							¥{{ item.product.price }}
						</div>
					</div>
				</div>
			</div>
		</van-list>
		<div class="no-goods" v-else-if="dataList && dataList.length == 0">
			<img class="img" src="@/assets/images/product/icon_no_goods.png" alt="" />
			<div class="text">抱歉，暂无查询到此商品呢～</div>
		</div>
		<div ref="maidian" td-event="2668024000,https://cloudmall.counton.com.cn/commbank-ip/#/productlsit"></div>
	</div>
</template>

<script>
import { baseUrl } from 'common/env'
import { Search } from 'vant'
import { areaList } from '@vant/area-data'
import { post } from 'api/post'
import { get } from 'api/get'
import TabBar from '@/components/tabBar/index'

export default {
	name: 'home',
	components: {
		TabBar,
	},
	data() {
		return {
			border: false,
			active: 0,
			timeOrder: 1,
			saleOrder: 0,
			priceOrder: 0,
			gridType: 0,
			column: 2,
			directionType: 'vertical',
			searchForm: {
				keyword: '',
				categoryCode: '',
				categoryCodeList: [],
				productIdList: [],
				channelCode: 'JH001',
				pageNum: 1,
				pageSize: 6,
				sort: '11',
			},
			dataList: null,
			// [
			// {
			//   product: {
			//     id: '',
			//     name: '',
			//     pic: '',
			//     price: '',
			//     freeTerm: '',
			//     freePrice: '', // 分期金额
			//   },
			//   channelPromotionList: [
			//     {
			//       id: '',
			//       type: '',
			//       limitAmt: '',
			//     },
			//   ],
			//   shopPromotionBest: {
			//     id: '',
			//     type: '',
			//     name: '',
			//     amount: '',
			//     minPoint: '',
			//   },
			// },
			// ],
			loading: false,
			finished: false,
			refreshing: false,
		}
	},
	created() {
		if (this.$route.query.categoryCode) {
			this.searchForm.categoryCode = this.$route.query.categoryCode
		}
		if (this.$route.query.categoryCodeList) {
			this.searchForm.categoryCodeList = JSON.parse(
				this.$route.query.categoryCodeList
			)
		}
		if (this.$route.query.productIdList) {
			this.searchForm.productIdList = JSON.parse(
				this.$route.query.productIdList
			)
		}

		this.loadContent()

		let self = this
		this.$nextTick(() => {
			self.$refs['maidian'].click()
		})
	},
	methods: {
		loadContent() {
			let self = this
			post('product/search', self.searchForm).then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))

					if (self.searchForm.pageNum == 1) {
						this.dataList = [] // 如果是第一页需手动置空列表
					}

					if (resData.list) {
						resData.list.forEach((item) => {
							if (item.product.freeTerm) {
								let freeTermArray = item.product.freeTerm.split(',')
								let free = freeTermArray[freeTermArray.length - 1]

								item.product.freePrice = self.$roundHalfUp(
									self.$divide(item.product.price, free),
									2
								)
							}
							item.product.price = self.$accounting.toFixed(
								item.product.price,
								2
							)
						})

						self.dataList = self.dataList.concat(resData.list) // 追加新数据
					}

					// 分页数据加载完毕
					if (self.refreshing) {
						self.dataList = []
						self.refreshing = false
					}

					self.loading = false

					// 全部数据已加载完毕
					if (self.dataList.length >= resData.total) {
						self.finished = true
					} else {
						self.searchForm.pageNum = self.searchForm.pageNum + 1
					}
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#00754a',
					})
				}
			})
		},
		/*onRefresh() {
								// 清空列表数据
								this.finished = false;

								// 重新加载数据
								// 将 loading 设置为 true，表示处于加载状态
								this.loading = true;
								this.loadHomeContent();
						},*/
		checkChannelPromotionExist(data) {
			if (!data.channelPromotionList || data.channelPromotionList.length < 1) {
				return false
			}

			return data.channelPromotionList.find((i) => i.type == '1')
		},
		getChannelPromotionDesc(data) {
			if (!data.channelPromotionList || data.channelPromotionList.length < 1) {
				return ''
			}

			let promotion = data.channelPromotionList.find((i) => i.type == '1')

			if (promotion) {
				return promotion.limitAmt + '%积分最高抵扣'
			}

			return ''
		},
		getShopPromotionDesc(data) {
			if (!data.shopPromotionBest) {
				return ''
			}

			if (data.shopPromotionBest.type == '1') {
				return (
					'满' +
					data.shopPromotionBest.minPoint +
					'减' +
					data.shopPromotionBest.amount
				)
			} else if (data.shopPromotionBest.type == '2') {
				return (
					'满' +
					data.shopPromotionBest.minPoint +
					'打' +
					data.shopPromotionBest.amount / 10 +
					'折'
				)
			}

			return ''
		},
		submit() { },
		changeTab() {
			if (this.active === 0) {
				if (this.timeOrder === '' || this.timeOrder === 0) {
					this.timeOrder = 1
					this.searchForm.sort = '11'
				} else {
					this.timeOrder = 0
					this.searchForm.sort = '10'
				}

				this.searchForm.pageNum = 1
				this.finished = false
				this.loading = true
				this.loadContent()
			} else if (this.active === 1) {
				if (this.saleOrder === '' || this.saleOrder === 0) {
					this.saleOrder = 1
					this.searchForm.sort = '21'
				} else {
					this.saleOrder = 0
					this.searchForm.sort = '20'
				}

				this.searchForm.pageNum = 1
				this.finished = false
				this.loading = true
				this.loadContent()
			} else if (this.active === 2) {
				if (this.priceOrder === '' || this.priceOrder === 0) {
					this.priceOrder = 1
					this.searchForm.sort = '31'
				} else {
					this.priceOrder = 0
					this.searchForm.sort = '30'
				}

				this.searchForm.pageNum = 1
				this.finished = false
				this.loading = true
				this.loadContent()
			} else if (this.active === 3) {
				// if (this.gridType === '' || this.gridType === 0) {
				//   this.gridType = 1
				//   this.column = 1
				//   this.directionType = 'horizontal'
				// } else {
				//   this.gridType = 0
				//   this.column = 2
				//   this.directionType = 'vertical'
				// }
			}
		},
		search() {
			this.searchForm.pageNum = 1
			this.finished = false
			this.loading = true
			this.loadContent()
		},
		onClickLeft() {
			window.history.back()
		},
		productDetail(publishId) {
			this.$router.push({
				path: '/productDetail',
				query: { publishId: publishId },
			})
		},
	},
}
</script>

<style>
.van-cell {
	padding: 10px 16px 10px 28px;
	font-size: 17px;
}

.overwrite_productList .van-tabs__line {
	background-color: #ffffff;
}
</style>

<style lang="less" scoped>
.product-list-page {
	box-sizing: border-box;
	background-color: #f7f7f7;
	height: 100vh;
	overflow-y: auto;

	.top-box {
		background-color: #fff;
		border-radius: 0px 0px 10px 10px;
		width: 100%;
		position: fixed;
		padding: 2px 0;
		top: 0;
		left: 0;
		z-index: 11;

		.search-box {
			box-sizing: border-box;
			margin: 0 auto;
			padding: 0 10px;
			width: 355px;
			height: 34px;
			background: #f5f5f5;
			border-radius: 10px;
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: flex-start;
			align-items: center;

			.icon {
				width: 16px;
				height: 16px;
				margin: 9px 0 9px 0;
			}

			.input {
				flex: 1;
				height: 20px;
				line-height: 20px;
				border: none;
				padding: 0 8px;
				background-color: unset;
				font-size: 13px;
				color: #333333;
				caret-color: #00754a;
			}

			.input::placeholder {
				font-size: 13px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #999999;
				line-height: 20px;
			}

			.icon-clear {
				width: 12px;
				height: 12px;
			}

			.line {
				margin: 0 10px;
				width: 1px;
				height: 12px;
				background-color: #cccccc;
			}

			.text {
				height: 16px;
				font-size: 13px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #00754a;
				line-height: 16px;
			}
		}

		.sort-style-box {
			display: flex;

			.van-tabs {
				flex: 1;
				padding: 12px 10px 0;
				background: #ffffff;

				.title-box {
					display: flex;
					flex-direction: row;
					flex-wrap: nowrap;
					align-content: center;
					justify-content: center;
					align-items: center;
					white-space: nowrap;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					color: #333333;
					font-size: 13px;
					height: 14px;
					line-height: 14px;

					.icon-sort {
						margin-left: 2px;
						width: 14px;
						height: 14px;
					}
				}

				/deep/.van-tabs__line {
					display: none;
				}
			}

			.style-box {
				width: 56px;
				display: flex;
				align-content: center;
				justify-content: center;
				align-items: center;
				margin-left: 25px;

				.icon-row-col {
					width: 16px;
					height: 16px;
				}
			}
		}
	}

	.h94 {
		height: 94px;
	}

	.van-list {
		padding: 10px 0;

		.goods-list {
			box-sizing: border-box;

			.goods-item {
				background: #ffffff;
				border-radius: 10px;

				.img {
					width: 90px;
					height: 90px;
					border-radius: 8px;
				}

				.goods-info {
					box-sizing: border-box;
					width: 100%;

					.title {
						width: 100%;
						max-height: 36px;
						font-size: 13px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #333333;
						line-height: 18px;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;

						.free-tag {
							padding: 1px 4px;
							background: #ff4e4e;
							border-radius: 4px;
							font-size: 11px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #ffffff;
						}
					}

					.tag {
						margin-top: 4px;
						display: inline-block;
						padding: 2px 4px;
						background: rgba(255, 78, 78, 0.06);
						border-radius: 4px;
						font-size: 11px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #ff4e4e;
					}

					.price {
						position: relative;
						font-size: 0;

						.symbol {
							font-size: 15px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #ff4e4e;
						}

						.num {
							font-size: 20px;
							font-family: 'DINA';
							font-weight: bold;
							color: #ff4e4e;
						}

						.text {
							font-size: 12px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #333333;
						}

						.sum-price {
							position: absolute;
							right: 0;
							bottom: 0;
							font-size: 11px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #cccccc;
						}
					}

					.sum-price {
						font-size: 11px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #cccccc;
					}
				}
			}
		}

		.showType-one {
			.goods-item {
				margin: 0 auto 10px;
				width: 355px;
				height: 110px;
				padding: 10px;
				box-sizing: border-box;
				display: flex;

				.img {
					width: 90px;
					height: 90px;
					border-radius: 8px;
				}

				.goods-info {
					margin-left: 10px;
					flex: 1;

					.price {
						margin-top: 9px;
					}
				}
			}

			.goods-item:last-child {
				margin: 0 auto;
			}
		}

		.showType-two {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			justify-content: flex-start;
			padding: 0 5px;

			.goods-item {
				margin: 0 5px;
				width: 172px;
				height: 280px;

				.img {
					width: 172px;
					height: 172px;
					border-radius: 10px 10px 0px 0px;
				}

				.goods-info {
					padding: 8px 10px;

					.price {
						margin-top: 5px;
					}

					.sum-price {
						margin-top: 8px;
					}
				}
			}

			.goods-item {
				margin-top: 10px;
			}

			.goods-item:nth-child(-n + 2) {
				margin-top: 0;
			}
		}
	}

	.no-goods {
		margin-top: 60px;
		text-align: center;

		.img {
			width: 110px;
			height: 100px;
		}

		.text {
			margin-top: 8px;
			height: 14px;
			font-size: 12px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #999999;
			line-height: 14px;
			text-align: center;
		}
	}
}

.bg-fff {
	background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/product/productList.vue